(() => {
  const dialog = document.getElementById('lc-welcome-offer');
  if (!dialog || dialog.dataset.initialized || typeof dialog.showModal !== 'function') return;
  dialog.dataset.initialized = 'true';
  const key = 'lc-first-order-2kd-seen-v1';
  let previousFocus = null;
  let oldOverflow = '';
  const markSeen = () => { try { sessionStorage.setItem(key, '1'); } catch {} };
  const close = () => { markSeen(); if (dialog.open) dialog.close(); };
  dialog.querySelectorAll('[data-offer-close]').forEach(button => button.addEventListener('click', close));
  dialog.addEventListener('click', event => {
    if (event.target !== dialog) return;
    const rect = dialog.getBoundingClientRect();
    if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) close();
  });
  dialog.addEventListener('close', () => {
    document.documentElement.style.overflow = oldOverflow;
    if (previousFocus && previousFocus.isConnected) previousFocus.focus({ preventScroll: true });
  });
  dialog.addEventListener('cancel', markSeen);
  dialog.querySelector('[data-offer-copy]').addEventListener('click', async event => {
    const button = event.currentTarget;
    const feedback = dialog.querySelector('[data-offer-feedback]');
    try {
      await navigator.clipboard.writeText('2KD');
      feedback.textContent = button.dataset.copied;
    } catch {
      feedback.textContent = button.dataset.failed;
      const selection = window.getSelection();
      if (selection) {
        const range = document.createRange();
        range.selectNodeContents(dialog.querySelector('.lc-offer-code'));
        selection.removeAllRanges();
        selection.addRange(range);
      }
    }
  });
  dialog.querySelector('.lc-offer-signin')?.addEventListener('click', markSeen);
  let seen = false;
  try { seen = sessionStorage.getItem(key) === '1'; } catch {}
  if (seen || window.Shopify?.designMode) return;
  const open = () => {
    if (document.visibilityState !== 'visible') return;
    if (document.querySelector('dialog[open], cart-drawer.active, details[open].menu-opening')) return;
    previousFocus = document.activeElement;
    oldOverflow = document.documentElement.style.overflow;
    dialog.showModal();
    document.documentElement.style.overflow = 'hidden';
    markSeen();
  };
  window.setTimeout(open, 1800);
})();
